var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIgnitionOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#4FAADB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_935_327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1998 11.1248C24.1998 14.618 21.368 17.4498 17.8748 17.4498C17.4716 17.4498 17.0774 17.4116 16.6951 17.3395L15.8322 18.3103C15.7512 18.4014 15.652 18.4742 15.5408 18.5241C15.4297 18.574 15.3093 18.5998 15.1875 18.5998H13.8498V20.0373C13.8498 20.5137 13.4637 20.8998 12.9873 20.8998H11.5498V22.3373C11.5498 22.8137 11.1637 23.1998 10.6873 23.1998H6.6623C6.18595 23.1998 5.7998 22.8137 5.7998 22.3373V19.5321C5.7998 19.3033 5.89069 19.0839 6.05241 18.9222L11.8672 13.1074C11.6615 12.4837 11.5498 11.8174 11.5498 11.1248C11.5498 7.63161 14.3816 4.79984 17.8748 4.7998C21.3783 4.79977 24.1998 7.62129 24.1998 11.1248ZM17.8748 9.39981C17.8748 10.3525 18.6471 11.1248 19.5998 11.1248C20.5525 11.1248 21.3248 10.3525 21.3248 9.39981C21.3248 8.4471 20.5525 7.6748 19.5998 7.6748C18.6471 7.6748 17.8748 8.4471 17.8748 9.39981Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_935_327"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(5 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgnitionOn);
export default __webpack_public_path__ + "static/media/ignition_on.18366e8b4a51505c11d87672a3b951a0.svg";
export { ForwardRef as ReactComponent };